import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { User, createUser } from './user.model';

export interface UserState {
  user: User;
}

export function createInitialState(): UserState {
  return {
    user: createUser({})
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'user' })
export class UserStore extends Store<UserState> {

  constructor() {
    super(createInitialState());
  }

}
